import "core-js/modules/es.array.push.js";
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostAgentMonthCommissionList } from '@/services/wms/commission';
export default {
  mixins: [cptCmn],
  components: {},
  data() {
    return {
      fItemDataIndex: undefined,
      searchForm: {
        startDate: undefined,
        endDate: undefined
      },
      btnLoading: false,
      listRequest: rqtPostAgentMonthCommissionList
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    // 日期组件自定义格式
    onPopupDateTimeSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.searchForm[this.fItemDataIndex] = undefined;
      this.$refs['PopupDatePickerCpt'].showView();
    },
    onDateTimeSelectedChange(val) {
      this.searchForm[this.fItemDataIndex] = val;
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    toURL(url, item) {
      this.$router.push({
        name: url,
        query: {
          agentMonthCommissionId: item.id,
          agentId: item.agentId,
          year: item.year,
          month: item.month
        }
      });
    }
  }
};